module.exports = __webpack_public_path__ + "static/media/west-coast-eagles-logo.23b225c9.svg";